// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/24934
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 24934 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
export const PageId = Object.freeze({
  Home_Main: 'Home_Main'
})

interface IPVTrackParamsRecord {
  /** 首页 */
Home_Main: undefined
}

const sendPv = {
  /** PV-首页 */
Home_Main: () => {
    eventTrackingUtils.submitPV({page_id:PageId.Home_Main});
  },
}

interface IExpoTrackParamsRecord {
  /** Top Banner曝光 */
Home_Banner_Expo: {
/** 位置  */
index: number,
/** 链接信息  */
url: string}
  /** 平台心智曝光 */
Home_Platform_Mind_Expo: {
/** 标题  */
title: string,
/** 按钮样式 1-纵向,2-横向 */
styleType: | '1'| '2',
/** tab名称  */
tab_name: string}
  /** 新人楼层曝光 */
Home_Welcome_Expo: {
/** 商品id  */
skuid: string,
/** 位置  */
index: number}
  /** 促销秒杀曝光 */
Home_Pro_FlashSales_Expo: {
/** 商品id  */
skuid: string,
/** 位置  */
index: number}
  /** 营销活动聚合曝光（删除） */
Home_Pro_Activity_Expo: {
/** 位置  */
index: number,
/** 标题  */
title: string}
  /** 热门分类曝光 */
Home_Popular_Categories_Expo: {
/** 位置  */
index: number,
/** 一级类目id  */
firstcid: string,
/** 二级类目id  */
secondcid: string,
/** 三级类目id  */
thirdcid: string}
  /** 新品曝光（删除） */
Home_Pro_NewArrivals_Expo: {
/** 商品id  */
skuid: string,
/** 位置  */
index: number}
  /** BestSellers曝光 */
Home_Pro_BestSellers_Expo: {
/** 标题  */
title: string,
/** 类目tab名称  */
categoryTabName: string}
  /** 首页登录弹窗曝光（删除） */
Home_Login_Expo: undefined
  /** 首页地址选择曝光 */
Home_Locate_Expo: undefined
  /** 首页消息曝光（删除） */
Home_Message_Expo: undefined
  /** 首页搜索框曝光 */
Home_SearchBox_Expo: undefined
  /** 搜索按钮曝光 */
Home_SearchBtn_Expo: undefined
  /** 新人楼层查看更多曝光 */
Home_Welcome_More_Expo: undefined
  /** 促销秒杀查看更多曝光 */
Home_Pro_FlashSales_More_Expo: undefined
  /** BestSellers查看更多曝光 */
Home_Pro_BestSellers_More_Expo: undefined
  /** 促销新品查看更多曝光（删除） */
Home_Pro_NewArrivals_More_Expo: undefined
  /** 拍卖楼层曝光 */
Home_DutchAuction_Expo: {
/** 位置  */
index: number}
  /** 拍卖查看更多曝光 */
Home_DutchAuction_More_Expo: undefined
  /** Home_Ochama_User_Migrate */
Home_Ochama_User_Migrate: Array<{
/** ochama_source app-null,pc-null,m-null */
ochama_source: | 'app'| 'pc'| 'm',
/** 设备指纹id  */
fingerprintId: string,
/** ochama_userid  */
ochama_userid: string,
/** joybuy_source app-null,pc-null,m-null */
joybuy_source: | 'app'| 'pc'| 'm',
/** joybuy_fingerprintId  */
joybuy_fingerprintId: string,
/** joybuy_userid  */
joybuy_userid: string}>
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** Top Banner曝光 */
  Home_Banner_Expo:'Home_Banner_Expo',
/** 平台心智曝光 */
  Home_Platform_Mind_Expo:'Home_Platform_Mind_Expo',
/** 新人楼层曝光 */
  Home_Welcome_Expo:'Home_Welcome_Expo',
/** 促销秒杀曝光 */
  Home_Pro_FlashSales_Expo:'Home_Pro_FlashSales_Expo',
/** 营销活动聚合曝光（删除） */
  Home_Pro_Activity_Expo:'Home_Pro_Activity_Expo',
/** 热门分类曝光 */
  Home_Popular_Categories_Expo:'Home_Popular_Categories_Expo',
/** 新品曝光（删除） */
  Home_Pro_NewArrivals_Expo:'Home_Pro_NewArrivals_Expo',
/** BestSellers曝光 */
  Home_Pro_BestSellers_Expo:'Home_Pro_BestSellers_Expo',
/** 首页登录弹窗曝光（删除） */
  Home_Login_Expo:'Home_Login_Expo',
/** 首页地址选择曝光 */
  Home_Locate_Expo:'Home_Locate_Expo',
/** 首页消息曝光（删除） */
  Home_Message_Expo:'Home_Message_Expo',
/** 首页搜索框曝光 */
  Home_SearchBox_Expo:'Home_SearchBox_Expo',
/** 搜索按钮曝光 */
  Home_SearchBtn_Expo:'Home_SearchBtn_Expo',
/** 新人楼层查看更多曝光 */
  Home_Welcome_More_Expo:'Home_Welcome_More_Expo',
/** 促销秒杀查看更多曝光 */
  Home_Pro_FlashSales_More_Expo:'Home_Pro_FlashSales_More_Expo',
/** BestSellers查看更多曝光 */
  Home_Pro_BestSellers_More_Expo:'Home_Pro_BestSellers_More_Expo',
/** 促销新品查看更多曝光（删除） */
  Home_Pro_NewArrivals_More_Expo:'Home_Pro_NewArrivals_More_Expo',
/** 拍卖楼层曝光 */
  Home_DutchAuction_Expo:'Home_DutchAuction_Expo',
/** 拍卖查看更多曝光 */
  Home_DutchAuction_More_Expo:'Home_DutchAuction_More_Expo',
/** Home_Ochama_User_Migrate */
  Home_Ochama_User_Migrate:'Home_Ochama_User_Migrate',
})

interface IClickTrackParamsRecord {
  /** 首页地址选择点击 */
Home_Locate: undefined
  /** 首页消息点击（删除） */
Home_Message: undefined
  /** 首页搜索框点击 */
Home_SearchBox: undefined
  /** 搜索按钮点击 */
Home_SearchBtn: {
/** 关键词  */
keyWord: string,
/** 搜索流量来源  */
searchtype: string}
  /** Top Banner点击 */
Home_Banner: {
/** 位置  */
index: number,
/** 链接信息  */
url: string}
  /** 平台心智点击 */
Home_Platform_Mind: {
/** 标题  */
title: string,
/** 按钮样式 1-纵向,2-横向 */
styleType: | '1'| '2',
/** tab名称  */
tab_name: string}
  /** 新人楼层点击 */
Home_Welcome: {
/** 位置  */
index: number,
/** 商品id  */
skuid: string}
  /** 促销秒杀点击 */
Home_Pro_FlashSales: {
/** 位置  */
index: number,
/** 商品id  */
skuid: string}
  /** 营销活动聚合点击（删除） */
Home_Pro_Activity: {
/** 标题  */
title: string,
/** 位置  */
index: number}
  /** 热门分类点击 */
Home_Popular_Categories: {
/** 位置  */
index: number,
/** 一级类目id  */
firstcid: string,
/** 二级类目id  */
secondcid: string,
/** 三级类目id  */
thirdcid: string}
  /** 新品点击（删除） */
Home_Pro_NewArrivals: {
/** 位置  */
index: number,
/** 商品id  */
skuid: string}
  /** BestSellers点击 */
Home_Pro_BestSellers: {
/** 标题  */
title: string,
/** 类目tab名称  */
categoryTabName: string}
  /** 新人楼层查看更多点击 */
Home_Welcome_More: undefined
  /** 促销秒杀查看更多点击 */
Home_Pro_FlashSales_More: undefined
  /** BestSellers查看更多点击 */
Home_Pro_BestSellers_More: undefined
  /** 促销新品查看更多点击（删除） */
Home_Pro_NewArrivals_More: undefined
  /** 首页登录弹窗点击（删除） */
Home_Login: undefined
  /** 拍卖楼层点击 */
Home_DutchAuction: {
/** 位置  */
index: number}
  /** 拍卖查看更多点击 */
Home_DutchAuction_More: undefined
}

const sendClickTrack = {
  /** 点击事件上报-首页地址选择点击 */
Home_Locate: () => {
    eventTrackingUtils.submitCL({event_id:'Home_Locate'});
  },
  /** 点击事件上报-首页消息点击（删除） */
Home_Message: () => {
    eventTrackingUtils.submitCL({event_id:'Home_Message'});
  },
  /** 点击事件上报-首页搜索框点击 */
Home_SearchBox: () => {
    eventTrackingUtils.submitCL({event_id:'Home_SearchBox'});
  },
  /** 点击事件上报-搜索按钮点击 */
Home_SearchBtn: (json_param: IClickTrackParamsRecord['Home_SearchBtn']) => {
    eventTrackingUtils.submitCL({event_id:'Home_SearchBtn',json_param});
  },
  /** 点击事件上报-Top Banner点击 */
Home_Banner: (json_param: IClickTrackParamsRecord['Home_Banner']) => {
    eventTrackingUtils.submitCL({event_id:'Home_Banner',json_param});
  },
  /** 点击事件上报-平台心智点击 */
Home_Platform_Mind: (json_param: IClickTrackParamsRecord['Home_Platform_Mind']) => {
    eventTrackingUtils.submitCL({event_id:'Home_Platform_Mind',json_param});
  },
  /** 点击事件上报-新人楼层点击 */
Home_Welcome: (json_param: IClickTrackParamsRecord['Home_Welcome']) => {
    eventTrackingUtils.submitCL({event_id:'Home_Welcome',json_param});
  },
  /** 点击事件上报-促销秒杀点击 */
Home_Pro_FlashSales: (json_param: IClickTrackParamsRecord['Home_Pro_FlashSales']) => {
    eventTrackingUtils.submitCL({event_id:'Home_Pro_FlashSales',json_param});
  },
  /** 点击事件上报-营销活动聚合点击（删除） */
Home_Pro_Activity: (json_param: IClickTrackParamsRecord['Home_Pro_Activity']) => {
    eventTrackingUtils.submitCL({event_id:'Home_Pro_Activity',json_param});
  },
  /** 点击事件上报-热门分类点击 */
Home_Popular_Categories: (json_param: IClickTrackParamsRecord['Home_Popular_Categories']) => {
    eventTrackingUtils.submitCL({event_id:'Home_Popular_Categories',json_param});
  },
  /** 点击事件上报-新品点击（删除） */
Home_Pro_NewArrivals: (json_param: IClickTrackParamsRecord['Home_Pro_NewArrivals']) => {
    eventTrackingUtils.submitCL({event_id:'Home_Pro_NewArrivals',json_param});
  },
  /** 点击事件上报-BestSellers点击 */
Home_Pro_BestSellers: (json_param: IClickTrackParamsRecord['Home_Pro_BestSellers']) => {
    eventTrackingUtils.submitCL({event_id:'Home_Pro_BestSellers',json_param});
  },
  /** 点击事件上报-新人楼层查看更多点击 */
Home_Welcome_More: () => {
    eventTrackingUtils.submitCL({event_id:'Home_Welcome_More'});
  },
  /** 点击事件上报-促销秒杀查看更多点击 */
Home_Pro_FlashSales_More: () => {
    eventTrackingUtils.submitCL({event_id:'Home_Pro_FlashSales_More'});
  },
  /** 点击事件上报-BestSellers查看更多点击 */
Home_Pro_BestSellers_More: () => {
    eventTrackingUtils.submitCL({event_id:'Home_Pro_BestSellers_More'});
  },
  /** 点击事件上报-促销新品查看更多点击（删除） */
Home_Pro_NewArrivals_More: () => {
    eventTrackingUtils.submitCL({event_id:'Home_Pro_NewArrivals_More'});
  },
  /** 点击事件上报-首页登录弹窗点击（删除） */
Home_Login: () => {
    eventTrackingUtils.submitCL({event_id:'Home_Login'});
  },
  /** 点击事件上报-拍卖楼层点击 */
Home_DutchAuction: (json_param: IClickTrackParamsRecord['Home_DutchAuction']) => {
    eventTrackingUtils.submitCL({event_id:'Home_DutchAuction',json_param});
  },
  /** 点击事件上报-拍卖查看更多点击 */
Home_DutchAuction_More: () => {
    eventTrackingUtils.submitCL({event_id:'Home_DutchAuction_More'});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}